export enum BankToggleOptions {
  existingAccount = 'existing-account',
  newAccount = 'new-account',
}
